'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import {
  LayoutDashboard,
  Package,
  ShoppingCart,
  CreditCard,
  Users,
} from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const BOTTOM_NAV_ITEMS = [
  { href: '/', label: 'Dashboard', icon: LayoutDashboard },
  { href: '/lot-management', label: 'Lots', icon: Package },
  { href: '/sales-management', label: 'Sales', icon: ShoppingCart },
  { href: '/buyer-management', label: 'Buyers', icon: Users },
  { href: '/payment-management', label: 'Payments', icon: CreditCard },
];

export default function BottomNav() {
  const pathname = usePathname();

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-card/95 backdrop-blur-md border-t border-border h-16 flex items-center justify-around px-2">
      {BOTTOM_NAV_ITEMS?.map((item) => {
        const isActive = pathname === item?.href;
        const Icon = item?.icon;
        return (
          <Link
            key={`bottom-nav-${item?.href}`}
            href={item?.href}
            className={`flex flex-col items-center gap-0.5 px-3 py-2 rounded-xl transition-all duration-150 min-w-[56px] ${
              isActive
                ? 'text-primary' :'text-muted-foreground hover:text-foreground'
            }`}
          >
            <div className={`p-1.5 rounded-lg transition-all ${isActive ? 'bg-primary/10' : ''}`}>
              <Icon size={18} strokeWidth={isActive ? 2.5 : 2} />
            </div>
            <span className="text-2xs font-medium">{item?.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}